export default __webpack_public_path__ + "static/media/do.112f9da2.svg";